export default __webpack_public_path__ + "static/media/icon-pencil-edit.eee5b0f9.svg";